import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ca-heart-button',
    templateUrl: './heart-button.component.html',
    styleUrls: ['./heart-button.component.scss'],
    standalone: false
})
export class HeartButtonComponent {
  @Output() onHearted: EventEmitter<boolean> = new EventEmitter();
  @Input() active: boolean;
  @Input() outline: boolean;
  public animate = false;

  trigger($event) {
    // We only want to trigger the animation if the button was clicked - not as a result of the input changing
    this.animate = !this.active;
    // the button is potentially sitting on top of a clickable card, so we prevent the event bubbling to it
    $event.stopPropagation();
    $event.preventDefault();
    this.onHearted.emit(this.active);
    return false;
  }
}
